import { createAsyncThunk } from "@reduxjs/toolkit";
import webhookAPIs from "services/api/publisher/webhookAPIs";

export const createWebhook = createAsyncThunk("clientWebhook/createWebhook", async (payload) => {
  try {
    const response = await webhookAPIs.createWebhook(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    const errorMessage = error?.response?.data?.error?.message;
    const message = Array.isArray(errorMessage) ? errorMessage.join(", ") : errorMessage;
    const errorObj = { ...(error?.response?.data?.error || error), message };
    throw errorObj;
  }
});

export const listWebhook = createAsyncThunk("clientWebhook/listWebhook", async (payload) => {
  try {
    const response = await webhookAPIs.listWebhook(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteWebhook = createAsyncThunk("clientWebhook/deleteWebhook", async (payload) => {
  try {
    const response = await webhookAPIs.deleteWebhook(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
